var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAdvisorSave = function SvgIconAdvisorSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1v.84c0 1.176 0 1.764-.225 2.213a2.082 2.082 0 0 1-.901.918C10.433 5.2 9.855 5.2 8.7 5.2H1m0 0 2.75-2.8M1 5.2 3.75 8",
    stroke: "#0067FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-no-fill": "true"
  })));
};
export { SvgIconAdvisorSave as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTMgOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTEyIDFWMS44NEMxMiAzLjAxNjExIDEyIDMuNjA0MTcgMTEuNzc1MiA0LjA1MzM4QzExLjU3NzUgNC40NDg1MiAxMS4yNjE5IDQuNzY5NzggMTAuODczOSA0Ljk3MTExQzEwLjQzMjcgNS4yIDkuODU1MTEgNS4yIDguNyA1LjJIMU0xIDUuMkwzLjc1IDIuNE0xIDUuMkwzLjc1IDgiCiAgICAgICAgc3Ryb2tlPSIjMDA2N0ZGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGRhdGEtbm8tZmlsbD0idHJ1ZSIvPgo8L3N2Zz4K";